import { useState, useCallback } from 'react'
import { PageLayout } from '@/components/layout'
import QuickOrderList from '@/components/quick-order/QuickOrderList'
import QuickOrderForm from '@/components/quick-order/QuickOrderForm'
import useQuickOrders from '@/hooks/useQuickOrders'

export default function QuickOrderPage({ user, onLogout }) {
  const [view, setView] = useState('list') // 'list' | 'add' | 'edit'
  const [editingOrder, setEditingOrder] = useState(null)

  const {
    orders,
    customers,
    products,
    productTypes,
    loading,
    filter,
    setFilter,
    createOrder,
    updateOrder,
    deleteOrder,
    loadPriceLists,
    loadBranches,
    multiplierToDiscountPercent
  } = useQuickOrders()

  const handleAdd = useCallback(() => {
    setEditingOrder(null)
    setView('add')
  }, [])

  const handleEdit = useCallback((order) => {
    setEditingOrder(order)
    setView('edit')
  }, [])

  const handleSave = useCallback(async (saleData, items) => {
    if (editingOrder) {
      await updateOrder(editingOrder.id, saleData, items)
    } else {
      await createOrder(saleData, items)
    }
    setView('list')
    setEditingOrder(null)
  }, [editingOrder, createOrder, updateOrder])

  const handleDelete = useCallback(async (saleId) => {
    await deleteOrder(saleId)
    setView('list')
    setEditingOrder(null)
  }, [deleteOrder])

  const handleCancel = useCallback(() => {
    setView('list')
    setEditingOrder(null)
  }, [])

  return (
    <PageLayout
      title={view === 'list' ? 'Quick Order' : undefined}
      user={user}
      onLogout={onLogout}
      showFooter={view === 'list'}
      className={view !== 'list' ? 'bg-white' : undefined}
    >
      <div className="max-w-lg mx-auto">
        {view === 'list' ? (
          <QuickOrderList
            orders={orders}
            filter={filter}
            onFilterChange={setFilter}
            onAdd={handleAdd}
            onEdit={handleEdit}
            loading={loading}
          />
        ) : (
          <QuickOrderForm
            order={view === 'edit' ? editingOrder : null}
            customers={customers}
            products={products}
            productTypes={productTypes}
            loadPriceLists={loadPriceLists}
            loadBranches={loadBranches}
            multiplierToDiscountPercent={multiplierToDiscountPercent}
            onSave={handleSave}
            onDelete={handleDelete}
            onCancel={handleCancel}
          />
        )}
      </div>
    </PageLayout>
  )
}
